module.exports = __webpack_public_path__ + "static/media/oil2.196f8ac5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/oil2.jpg
// module id = 5829
// module chunks = 0